import React, { useEffect } from 'react'
import { AnnouncementItemCSS } from './AnnouncementItemCSS.styled'
import { useYoloToast } from 'lib/yoloToasts/useYoloToast'

interface AnnouncementItemProps {
  data: TParsedMessage
  noToast: boolean
}

export const AnnouncementItem: React.FC<AnnouncementItemProps> = ({ data, noToast }) => {
  const { yToast } = useYoloToast()
  const { emoji, title, paragraph } = data.message as TAnnouncementBody

  useEffect(() => {
    if (noToast) return
    const announcementToastObj = {
      id: 'announceToast',
      autoClose: false,
      props: {
        emoji,
        message: {
          title: <strong>{title}</strong>,
          subtitle: paragraph,
        },
      },
    }
    yToast(announcementToastObj)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <AnnouncementItemCSS>
      <div className='message user announcement'>
        <div className='user_avatar'>
          <div className='avatar_image twentyfour'>{emoji}</div>
        </div>
        <div className='message_content'>
          <span className='user_name'> {title}</span>
          <span className='message_copy'>{paragraph}</span>
        </div>
      </div>
    </AnnouncementItemCSS>
  )
}
